import React, { useEffect, useState } from 'react'

import SelectOrganization from '../../components/SelectOrganization/SelectOrganization'
import CustomSelect from '../../components/CustomSelect/customSelect'
import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'
import { isAdmin } from '../../util/profiles'

const ProductivityReportFilter = ({
  errors = {},
  currentUser,
  values,
  setFieldValue,
  formattedRegions,
  formattedDistricts,
  formattedMembers,
  customerList,
  onChangeRegion,
  onChangeOrganization,
  onChangeDistrict
}) => {
  const [timeOptions, setTimeOptions] = useState([])
  const isCurrentUserAdmin = isAdmin(currentUser)
  const rowSpan = isCurrentUserAdmin ? 4 : 6

  useEffect(() => {
    fetchHarvests()
  }, [])

  async function fetchHarvests() {
    let items = await request(api.listSafra({ active: true }))

    items = items.filter(({ referencePeriodRanges }) => referencePeriodRanges && referencePeriodRanges.length)

    const formattedValues = items.map((item) => ({
      value: item.id,
      description: item.name
    }))

    setTimeOptions(formattedValues)
  }

  return (
    <>
      <CustomSelect
        showSearch
        field="period"
        errors={errors}
        setFieldValue={setFieldValue}
        rowSpan={rowSpan}
        value={values}
        values={timeOptions}
        required
      />
      <SelectOrganization
        errors={errors}
        field="organization"
        setFieldValue={setFieldValue}
        formValues={values}
        rowSpan={rowSpan}
        onChangeWithField={onChangeOrganization}
        required
      />
      <CustomSelect
        showSearch
        multiple
        enable={isCurrentUserAdmin && !values.organization}
        field="reportFilterRegional"
        errors={errors}
        setFieldValue={setFieldValue}
        rowSpan={rowSpan}
        value={values}
        values={formattedRegions}
        onChange={onChangeRegion}
        required
      />
      <CustomSelect
        showSearch
        multiple
        enable={Boolean(!values.reportFilterRegional || values.reportFilterRegional.length === 0)}
        field="reportFilterDistrict"
        errors={errors}
        setFieldValue={setFieldValue}
        rowSpan={rowSpan}
        value={values}
        onChange={onChangeDistrict}
        values={formattedDistricts}
      />
      <CustomSelect
        showSearch
        multiple
        field="reportFilterMember"
        label={getMessage('report_professional')}
        errors={errors}
        setFieldValue={setFieldValue}
        rowSpan={rowSpan}
        value={values}
        values={formattedMembers}
      />
      <CustomSelect
        showSearch
        multiple
        required
        onSearch={(value) => console.log(value)}
        field="reportFilterCustomer"
        label={getMessage('listCustomer')}
        errors={errors}
        setFieldValue={setFieldValue}
        rowSpan={rowSpan}
        value={values}
        values={customerList}
      />
    </>
  )
}

export default ProductivityReportFilter
